const getConsentDate = () => {
  const d = new Date();
  d.setMonth(d.getMonth() + 13);
  d.setDate(d.getDate() - 1);
  return d.toUTCString();
};

const getSidDate = () => {
  const d = new Date();
  d.setMonth(d.getMonth() + 1);
  return d.toUTCString();
};

const getSznaiidDate = () => {
  const d = new Date();
  d.setMonth(d.getMonth() + 1);
  return d.toUTCString();
};

const commonCookieOptions = {
  domain: '.' + location.hostname.split('.').slice(-2).join('.'),
  secure: location.protocol === 'https:',
  path: '/',
};

export const getConsentCookieOptions = () => ({
  ...commonCookieOptions,
  expires: getConsentDate(),
});

export const getSidCookieOptions = () => ({
  ...commonCookieOptions,
  expires: getSidDate(),
});

export const getSznaiidCookieOptions = () => ({
  ...commonCookieOptions,
  expires: getSznaiidDate(),
});
